import { camelCase } from '../helpers/generic_utils';

const env = {};

Object.keys(process.env).forEach((key) => {
  if (key.startsWith('REACT_APP_')) {
    // convert keys like `REACT_APP_LOGIN_HOST` to `loginHost`
    let newKey = camelCase(key.replace(/^(REACT_APP_)/, ''));
    // process.env variable always return strings.
    // String 'false' evaluates to boolean true, which isn't obvious in usages of this config.
    // So - detect string 'false' and force it to boolean false.
    env[newKey] = process.env[key] === 'false' ? false : process.env[key];
  }
});

export default env;
